"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListingUseType = exports.default = void 0;
var _listingType = _interopRequireDefault(require("./listing-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ListingUseType;
(function (ListingUseType) {
  ListingUseType["RESIDENTIAL"] = "residential";
  ListingUseType["COMMERCIAL"] = "commercial";
  ListingUseType["BUSINESS"] = "business";
})(ListingUseType || (ListingUseType = {}));
var getListingUseType = listingType => {
  if (!listingType) {
    return undefined;
  }
  if (listingType.name === _listingType.default.SALES_BUSINESS.name) {
    return ListingUseType.BUSINESS;
  }
  return listingType.isCommercial ? ListingUseType.COMMERCIAL : ListingUseType.RESIDENTIAL;
};
exports.getListingUseType = getListingUseType;
var _default = exports.default = ListingUseType;